import config from "../config";

const imageUrl = url => {
  const baseUrl = config.urls.baseBackendURL;
  return `${baseUrl}${url}`;
};

export default imageUrl;
